'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _DatePicker = require('./DatePicker.scss');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _reactIntl = require('react-intl');

var _Calendar = require('containers/Calendar/Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SearchMobile: {
    displayName: 'SearchMobile'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Calendar/DatePicker.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
// import _ from 'lodash';

var SearchMobile = _wrapComponent('SearchMobile')((_dec = (0, _reactCssModules2.default)(_DatePicker2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SearchMobile, _Component);

  function SearchMobile(props) {
    (0, _classCallCheck3.default)(this, SearchMobile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchMobile.__proto__ || (0, _getPrototypeOf2.default)(SearchMobile)).call(this, props));

    _this.onChangeDate = _this.onChangeDate.bind(_this);

    if (!(typeof _this.onChangeDate === 'function')) {
      throw new TypeError('Value of "this.onChangeDate" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeDate));
    }

    _this.onChangeFlex = _this.onChangeFlex.bind(_this);

    if (!(typeof _this.onChangeFlex === 'function')) {
      throw new TypeError('Value of "this.onChangeFlex" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeFlex));
    }

    return _this;
  }

  (0, _createClass3.default)(SearchMobile, [{
    key: 'onChangeDate',
    value: function onChangeDate(date) {
      this.props.onChangeDate(date);
    }
  }, {
    key: 'onChangeFlex',
    value: function onChangeFlex(e) {
      this.props.onChangeFlex(e.target.checked);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          date = _props.date,
          isFlexibleDate = _props.isFlexibleDate;

      return _react3.default.createElement(
        'div',
        { styleName: 'calendar-inner', onClick: this.innerClick },
        _react3.default.createElement(_Calendar2.default, { free: true, onChange: this.onChangeDate, initialDate: date ? (0, _momentTimezone2.default)(date) : date }),
        _react3.default.createElement(
          'div',
          { styleName: 'flex-container' },
          _react3.default.createElement(
            'label',
            { styleName: 'custom-checkbox' },
            _react3.default.createElement('input', { type: 'checkbox', checked: isFlexibleDate, onChange: this.onChangeFlex }),
            _react3.default.createElement(
              'span',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'datepicker.flex_date' })
            )
          ),
          _react3.default.createElement(
            'a',
            { styleName: 'clear', onClick: this.onChangeDate.bind(this, null) },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'datepicker.any_date' })
          )
        )
      );
    }
  }]);
  return SearchMobile;
}(_react2.Component), _class2.propTypes = {
  onChangeDate: _react2.PropTypes.func,
  onChangeFlex: _react2.PropTypes.func,
  date: _react2.PropTypes.any,
  isFlexibleDate: _react2.PropTypes.bool
}, _temp)) || _class));

exports.default = SearchMobile;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Calendar/DatePicker.js
// module id = 455
// module chunks = 47